module.exports = __webpack_public_path__ + "img/add-photo-sixth-icon-male.40e81bad.svg";